<template>
  <el-dialog
    :visible="visible"
    :title="$t('management.dataView.widget_config')"
    custom-class="no-padding-dialog"
    :close-on-click-modal="false"
    @update:visible="updateVisible"
    :area="[340, 480]"
    top="middle"
  >
    <el-form
      :model="formData"
      label-position="top"
      style="padding: 0 12px;"
    >
      <el-form-item
        v-for="item in options"
        :key="item.key"
        :label="item.label"
        :introduction="item.desc"
      >
        <el-input
          v-model="formData[item.key]"
          v-if="item.optionType === 'input'"
        ></el-input>
        <el-input
          v-model="formData[item.key]"
          v-if="item.optionType === 'textarea'"
        ></el-input>
        <el-radio-group
          v-model="formData[item.key]"
          v-if="item.optionType === 'radio'"
        >
          <el-radio
            v-for="option in item.options"
            :key="option.value"
            :label="option.value"
          >{{option.name}}</el-radio>
        </el-radio-group>
        <el-switch
          v-model="formData[item.key]"
          v-if="item.optionType === 'switch'"
        ></el-switch>
        <el-select
          v-model="formData[item.key]"
          v-if="item.optionType === 'select'"
        >
          <el-option
            v-for="option in item.options"
            :key="option.value"
            :label="option.name"
            :value="option.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button
        type="primary"
        @click="submitForm"
      >{{$t('common.confirmBtn_text')}}</el-button>
      <el-button @click="cancel">{{$t('common.cancelBtn_text')}}</el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'data-view-setting-dialog',
  props: {
    visible: Boolean,
    target: Object
  },
  data () {
    return {
      options: [],
      formData: {}
    }
  },
  watch: {
    visible (flag) {
      if (flag) {
        this.options = JSON.parse(JSON.stringify(this.target.setting))
        this.formData = {}
        Object.keys(this.target.option).forEach(key => {
          this.$set(this.formData, key, this.target.option[key])
        })
      }
    }
  },
  methods: {
    // 根据配置的参数类型转化表单填写结果
    formatValue (item) {
      let _value = this.formData[item.key]
      if (item.type === 'string') {
        return _value.toString()
      } else if (item.type === 'integer') {
        return parseInt(_value)
      } else if (item.type === 'float') {
        return parseFloat(_value)
      } else if (item.type === 'boolean') {
        return !!_value
      }
    },
    updateVisible (flag) {
      this.$emit('update:visible', flag)
    },
    submitForm () {
      this.options.forEach(item => {
        this.$set(this.target.option, item.key, this.formatValue(item))
      })
      this.updateVisible(false)
    },
    cancel () {
      this.updateVisible(false)
    }
  }
}
</script>

<style lang="less">
.no-padding-dialog {
  .el-dialog__body {
    padding-left: 0px;
    padding-right: 0px;
  }
}
</style>
